<template>
  <v-card v-if="getProductHardwareError">
    <v-card-title>
      Bring your own hardware
      <v-spacer></v-spacer>
    </v-card-title>
    <v-card-text>There was an error loading this component</v-card-text>
  </v-card>

  <v-card v-else class="align-stretch" height="100%" :loading="getProductHardwareLoading">
    <v-card-title>
      Bring your own hardware
      <v-spacer></v-spacer>
      <EditProductHardware />
    </v-card-title>

    <v-card-text>
      <p class="mb-1 text-caption">Hardware selected</p>
      <template v-for="(item, i) in getProductHardware">
        <div :key="`hw-list-${i}`">
          <b>{{ item.name }}</b> 
          <b v-if="item.quantity">({{ item.quantity }})</b>
          <template v-for="(mac, j) in item.mac_addresses">
            <p :key="j" class="pl-6"><b>{{ mac | defaultMac }}</b></p>
          </template>
          <p class="mt-n4 text-caption">{{ mapDifficulty(item.difficulty) }}</p>
        </div>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import EditProductHardware from "@/components/Products/ProductHardware/EditProductHardware";

export default {
  components: { EditProductHardware },

  data() {
    return {
      loading: false,
    }
  },

  filters: {
    defaultMac(val) {
      if(!val) return "-";
      return val;
    },
    titleCase(str) {
      if(str===''){ return ''; }
      return str.toLowerCase().split(' ').map(function(word) {
        return word.replace(word[0], word[0].toUpperCase());
      }).join(' ');
    },
  },

  computed: {
    ...mapState('products',['currentProduct']),
    ...mapGetters("productHardware", ["getProductHardware", "getProductHardwareError", "getProductHardwareLoading"]),
  },

  methods: {
    ...mapActions('productHardware', ['resetDefault','fetchAvailableHardware', 'fetchProductHardware', 'updateProductHardware', 'addLocalProductHardware', 'updateLocalProductHardware']),

    mapDifficulty(val) {
      return ['medium', 'hard'].includes(val.toLowerCase()) ? `This device is '${val.toLowerCase()}' hardware provisioning difficulty. Please manage the customer's expectations accordingly.`: '';
    },
  },

  async created() {
    await this.fetchAvailableHardware({ platform: this.currentProduct.supplier });
    await this.fetchProductHardware({ productId: this.currentProduct.id });
  }
}
</script>

<style>

</style>
